
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 17 17"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"stroke":"#798F8F","d":"M11 11.257a1 1 0 0 0 1 0l3-1.732a1 1 0 0 0 .5-.866V5.196a1 1 0 0 0-.5-.866L12 2.6a1 1 0 0 0-1 0L8.001 4.33a1 1 0 0 0-.5.866V8.66a1 1 0 0 0 .5.866z"}}),_c('path',{attrs:{"stroke":"#798F8F","stroke-linecap":"round","d":"m8.605 13.247-3.586-2.07a1 1 0 0 1-.5-.867V6.17M5.588 14.544l-3.586-2.07a1 1 0 0 1-.5-.867V7.466"}})])
          )
        }
      }
    